import { NgModule } from '@angular/core';
import { SectionComponent } from 'app/views/presentations/layouts/layouts/section.component';
import { WidgetModule } from 'app/views/presentations/widgets/widget.module';

@NgModule({
    imports: [WidgetModule],
    declarations: [SectionComponent],
    exports: [SectionComponent]
})
export class SectionModule { }



// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/section.module.ts